module.exports = __webpack_public_path__ + "img/arrondi.8c627b8f.png";